// removed by extract-text-webpack-plugin
module.exports = {"link":"adminLink-module_link_1GUEQ","item":"adminLink-module_item_Ff0ir","text":"adminLink-module_text_QKm1j"};


//////////////////
// WEBPACK FOOTER
// ./client/components/siteHeader/header/adminLink.module.css
// module id = 399
// module chunks = 1 2